'use client';

import React from 'react';

import { Collapse } from '@kunukn/react-collapse'; // UMD
import '@kunukn/react-collapse/dist/react-collapse.css'; // CSS
import type { CollapseProps } from '@kunukn/react-collapse/dist/react-collapse.d.ts'; // TS

import classes from './floating-helper.module.scss';
import Link from 'next/link';

function FloatingHelper(props: CollapseProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleToggle = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <aside className={classes.floatingHelper}>
      <div className={classes.helperWrap}>
        <ul className={classes.helperMenuList}>
          <Collapse
            isOpen={isOpen}
            transition={props.transition || 'height 0.3s ease'}
            style={{
              ...props.style,
              overflow: props.isOpen ? 'visible' : 'hidden', // 슬라이드 시 overflow 숨김 처리
            }}
          >
            <li>
              <Link
                href="https://api.whatsapp.com/send/?phone=821059631771&text&type=phone_number&app_absent=0"
                target="_blank"
                className={`${classes.helperMenuBtn} ${classes.withCall}`}
              ></Link>
            </li>
            <li>
              <Link
                href="https://line.me/R/ti/p/@936lzxaz"
                target="_blank"
                className={`${classes.helperMenuBtn} ${classes.withLine}`}
              ></Link>
            </li>
            <li>
              <Link
                href="https://pf.kakao.com/_dnhnG"
                target="_blank"
                className={`${classes.helperMenuBtn} ${classes.withKakao}`}
              ></Link>
            </li>
          </Collapse>
        </ul>
        <button className={classes.helperBtn} onClick={handleToggle}></button>
      </div>
    </aside>
  );
}

export default FloatingHelper;
